import { useContext, useEffect, useState } from 'react'

import {
  GenderOptionControl,
  Label,
  theme,
  useHealthToolsCache,
} from '@hhgtech/hhg-components'
import { NavMenuContentType } from '@hhgtech/hhg-components/components/navigationV2/index'
import { QUERY_HEALTH_TOOL } from '@hhgtech/hhg-components/constants'
import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Flex, Stack, rem } from '@mantine/core'
import { isNotEmpty, useForm } from '@mantine/form'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'
import isEmpty from 'lodash/isEmpty'
import queryString from 'query-string'
import { useIntl } from 'react-intl'

import { redirectToSSOWithReturnUrl } from 'api/utils/redirects'
import { Container } from 'components/atoms/container'
import { AgeInput } from 'components/atoms/healthTools/form/ageInput'
import { CheckYourSelfSwitching } from 'components/atoms/healthTools/form/checkYourSelfSwitching'
import { SingleSlider } from 'components/atoms/singleSlider'
import { AdBlock } from 'components/molecules/adBlock'
import { FixedBottomAdBlock } from 'components/molecules/adBlock/deferFixedBottomAdBlock'
import { BmiFormHelpers } from 'components/molecules/bmiForm'
import { ExpandedCard } from 'components/molecules/expandedCard'
import { HealthToolBreadcrumb } from 'components/molecules/healthToolBreadcrumb'
import { RadioImageGroupForTool } from 'components/molecules/radioImageGroupForTool'
import { ToolsBannerCardV2 } from 'components/molecules/toolsBannerCardV2'
import { ToolsInfoCard } from 'components/molecules/toolsInfoCard'
import { ToolsSubmitButton } from 'components/molecules/toolsSubmitButton'
import { StyledFormControl } from 'components/organisms/babyGrowthForm/index.styled'
import MobileBottomNavigationWrapper from 'components/organisms/mobileBottomNavigationWrapper'
import { RelationTool } from 'components/organisms/relationTool'
import {
  StyledImageIcon,
  StyledThrHealthTool,
} from 'components/pages/healthTools/index.styled'
import {
  StyledActive,
  StyledBMIInfo,
  StyledInfo,
  StyledRightColumnContainer,
  StyledSlider,
  StyledSubmitButton,
} from 'components/pages/healthTools/index.thr.styled'
import { HealthToolLayout } from 'components/templates/healthToolLayout'
import { NavigatorLayout } from 'components/templates/navigatorLayout'
import { domainLocales } from 'domainLocales'
import { useCheckingYourself } from 'hooks/healthTools/useCheckingYourself'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import {
  API_DATE_FORMAT,
  ENV,
  THRINFO_COOKIE_KEY,
  assetImagePath,
} from 'interfaces/constants'
import { HEALTH_TOOL_TYPE } from 'interfaces/constants/healthTools'
import {
  FooterInfo,
  // HealthToolByCategory,
  HeartRateLocalStoredType,
  ThrInfo,
  targetHeartRateInfo,
} from 'interfaces/types'
import { AppContext } from 'state/appContext'
// import { getAdTag, getCountryAdTag, getLocaleCategoryAdTag } from 'utils/ads'
import { getAdTag, getCountryAdTag, getLocaleCategoryAdTag } from 'utils/ads'
import { fastdom } from 'utils/fastdom'
import { formatGenderUrl } from 'utils/format'
import {
  checkAndSaveUserInfo,
  formartSSOGenderToHealthtoolForm,
} from 'utils/healthTools'

import { ToolPageType } from './helpers'

export type InputError = {
  age: string
  intensity: string
}

export type Props = {
  type: ToolPageType
  isMobileSsr: boolean
  thrContent: ThrInfo
  pageType?: string
  userInfo?: any
  footerInfo?: FooterInfo
  dataNavMenuContent?: NavMenuContentType
}

const THRToolPage = ({ thrContent, footerInfo, dataNavMenuContent }: Props) => {
  const { formatMessage: f } = useIntl()

  const isMobile = useIsMobile()

  const { state } = useContext(AppContext) || {}
  const { isLoggedIn, userInfo } = state || {}

  const { locale, router, asPath } = useRouterExtend()
  const { getHealthToolLink } = useHealthToolsCache(locale)

  const {
    isCheckYourself,
    setIsCheckYourself,
    checkAvailableGenderOpt,
  } = useCheckingYourself()

  const form = useForm<{ birthday: Date; gender: string }>({
    validate: {
      birthday: isNotEmpty(
        f({
          id: 'targetHeartRate.ageInput.error',
          defaultMessage: 'Please enter your actual age',
        }),
      ),
      gender: isNotEmpty(
        f({
          id: 'tools.genderInput.error',
          defaultMessage: 'Please select gender',
        }),
      ),
    },
  })
  const [openInfo, setOpenInfo] = useState(-1)
  const [isAdult, setIsAdult] = useState(false)

  const rangeHeartRateByAge = [
    {
      idAge: 0,
      minAge: 0,
      maxAge: 18,
      rangeMale: 40,
      rangeFemale: 40,
    },
    {
      idAge: 1,
      minAge: 18,
      maxAge: 25,
      rangeMale: 49,
      rangeFemale: 54,
    },
    {
      idAge: 2,
      minAge: 25,
      maxAge: 35,
      rangeMale: 49,
      rangeFemale: 54,
    },
    {
      idAge: 3,
      minAge: 35,
      maxAge: 45,
      rangeMale: 50,
      rangeFemale: 54,
    },
    {
      idAge: 4,
      minAge: 45,
      maxAge: 55,
      rangeMale: 50,
      rangeFemale: 54,
    },
    {
      idAge: 5,
      minAge: 55,
      maxAge: 65,
      rangeMale: 51,
      rangeFemale: 54,
    },
    {
      idAge: 6,
      minAge: 65,
      maxAge: 120,
      rangeMale: 50,
      rangeFemale: 54,
    },
  ]

  const { DEPLOY_ENV } = ENV

  const [info, setInfo] = useState<targetHeartRateInfo>({
    yourSelf: 'self',
    gender: 'male',
    age: '',
    rate: '60',
    intensity: 'low_intensity',
  } as targetHeartRateInfo)

  const [inputErrorMessage, setInputErrorMessage] = useState<InputError>(
    {} as InputError,
  )
  const [heartRate, setHeartRate] = useState([60])
  const [range, setRange] = useState({
    idAge: 0,
    minAge: 0,
    maxAge: 18,
    rangeMale: 40,
    rangeFemale: 40,
  })
  const [genderValue, setGenderValue] = useState('male')
  const [activeValue, setActiveValue] = useState('')
  const activeValueNote = [
    {
      value: 'low_intensity',
      label: f({
        id: 'targetHeartRate.lowIntensity.title',
        defaultMessage: 'Low intensity',
      }),
      image: `${assetImagePath}/low.svg`,
      imageActive: `${assetImagePath}/low-active.svg`,
      content: f({
        id: 'targetHeartRate.lowIntensity.note',
        defaultMessage: 'Low intensity (little or no exercise)',
      }),
    },
    {
      value: 'moderate_intensity',
      label: f({
        id: 'targetHeartRate.moderateIntensity.title',
        defaultMessage: 'Moderate intensity',
      }),
      image: `${assetImagePath}/moderate.svg`,
      imageActive: `${assetImagePath}/moderate-active.svg`,
      content: f({
        id: 'targetHeartRate.moderateIntensity.note',
        defaultMessage: 'Moderate intensity (exercise/ sports 1-3 days/week)',
      }),
    },
    {
      value: 'aerobic_zone',
      label: f({
        id: 'targetHeartRate.aerobicZone.title',
        defaultMessage: 'Aerobic Zone',
      }),
      image: `${assetImagePath}/aerobic.svg`,
      imageActive: `${assetImagePath}/aerobic-active.svg`,
      content: f({
        id: 'targetHeartRate.aerobicZone.note',
        defaultMessage: 'Aerobic Zone (moderate exercise/sports 3-5 days/week)',
      }),
    },
    {
      value: 'vigorous_intensity',
      label: f({
        id: 'targetHeartRate.vigorousIntensity.title',
        defaultMessage: 'Vigorous Intensity',
      }),
      image: `${assetImagePath}/vigorous.svg`,
      imageActive: `${assetImagePath}/vigorous-active.svg`,
      content: f({
        id: 'targetHeartRate.vigorousIntensity.note',
        defaultMessage:
          'Vigorous Intensity (hard exercise/ sports 6-7 days/week)',
      }),
    },
    {
      value: 'maximum_intensity',
      label: f({
        id: 'targetHeartRate.maximumIntensity.title',
        defaultMessage: 'Maximum Intensity',
      }),
      image: `${assetImagePath}/maximum.svg`,
      imageActive: `${assetImagePath}/maximum-active.svg`,
      content: f({
        id: 'targetHeartRate.maximumIntensity.note',
        defaultMessage:
          'Maximum Intensity (very hard exercise/sports or x2 training)',
      }),
    },
  ]

  const validateInputs = () => {
    const _input = {} as InputError
    const newErrors: any = {}
    if (!parseInt(info.age)) {
      newErrors.age = f({
        id: 'targetHeartRate.ageInput.error',
        defaultMessage: 'Please enter your actual age',
      })
    }
    if (!activeValue && isAdult) {
      newErrors.intensity = f({
        id: 'targetHeartRate.levelActiveSelect.error',
        defaultMessage: 'Please select your active level',
      })
    }

    if (isEmpty(newErrors)) {
      return true
    } else {
      setInputErrorMessage({
        ..._input,
        ...newErrors,
      })
      return false
    }
  }
  const adUnitPath = getAdTag({
    countryAdTag: getCountryAdTag(locale, {
      isMobile,
    }),
    contentAdTag: getLocaleCategoryAdTag(locale, asPath, ['health-tools/thr']),
  })
  const enabledAd = !!thrContent?.enable_ad

  const onSubmit = () => {
    if (validateInputs()) {
      const gender = genderValue as string
      const currentOrigin = window.location.origin
      const currentPathname = window.location.pathname
      const level = !activeValue ? info.intensity : activeValue

      const thrInfo: HeartRateLocalStoredType = {
        gender: genderValue,
        age: info.age,
        rate: heartRate[0],
        intensity: level,
        source_url: window.location.href,
      }

      // set `thrInfo`
      Cookies.set(THRINFO_COOKIE_KEY, JSON.stringify(thrInfo), {
        domain: `.${domainLocales[locale]}`,
        path: '/',
      })
      ;(async () => {
        const destination = queryString.stringifyUrl({
          url: currentOrigin + currentPathname,
          query: {
            [QUERY_HEALTH_TOOL.gender]: formatGenderUrl(gender),
            [QUERY_HEALTH_TOOL.age]: info.age,
            [QUERY_HEALTH_TOOL.rate]: heartRate,
            [QUERY_HEALTH_TOOL.intensity]: level,
            joincommunity: 1,
          },
        })

        if (!isLoggedIn) {
          BmiFormHelpers.syncParamsToUseOnSSOForm(
            {
              gender: info.gender,
              birthday: dayjs(info?.age, API_DATE_FORMAT).toDate(),
            },
            router,
          )
          redirectToSSOWithReturnUrl(destination, 'target-heart-rate')
        } else {
          if (userInfo?.id && info?.age) {
            await checkAndSaveUserInfo({
              userInfo,
              data: {
                birthday: dayjs(info?.age, API_DATE_FORMAT).toDate(),
              },
            })
          }
          router.push(destination)
        }
      })()
    }
  }

  const thrInfo = {
    title: f({
      id: 'tools.info',
      defaultMessage: 'Info',
    }),
    items: thrContent.info,
  }

  const openHowToMeasure = () => {
    setOpenInfo(0)
    fastdom.measure(() => {
      const element = document.getElementById(
        'expandedCard',
      ) as HTMLInputElement
      const y = element.getBoundingClientRect().top + window.pageYOffset - 100
      window.scrollTo({ top: y, behavior: 'smooth' })
    })
  }
  useEffect(() => {
    if (isLoggedIn) {
      setIsCheckYourself(true)
      if (userInfo?.birthday) {
        form.setFieldValue(
          'birthday',
          dayjs(userInfo?.birthday, API_DATE_FORMAT).toDate(),
        )
        setGenderValue(userInfo?.gender ? 'male' : 'female')
        setInfo({
          ...info,
          age: userInfo?.birthday,
        })
      }
    }
  }, [isLoggedIn])

  useEffect(() => {
    if (isCheckYourself) {
      userInfo?.gender !== -1 &&
        form.setFieldValue(
          'gender',
          formartSSOGenderToHealthtoolForm(userInfo?.gender || 0),
        )
      if (userInfo?.birthday) {
        form.setFieldValue(
          'birthday',
          dayjs(userInfo?.birthday, API_DATE_FORMAT).toDate(),
        )
        setInfo({
          ...info,
          age: userInfo?.birthday,
        })
      }
    } else {
      form.reset()
    }
  }, [isCheckYourself, userInfo])

  useEffect(() => {
    const age = (new Date().getTime() - new Date(info.age).getTime()) / 1000
    if (age >= 18 * 365 * 24 * 60 * 60) setIsAdult(true)
    else setIsAdult(false)

    const rangeByAge =
      rangeHeartRateByAge.find(
        (item) =>
          age >= item.minAge * 365 * 24 * 60 * 60 &&
          age < item.maxAge * 365 * 24 * 60 * 60,
      ) || rangeHeartRateByAge[0]
    setRange(rangeByAge)
    setHeartRate([60])
  }, [info.age])

  const pageItem = [
    {
      label: f({ id: 'healthtools.title' }),
      value: `/health-tools`,
    },
    {
      label: f({
        id: 'targetHeartRate.seoTitle',
        defaultMessage: 'Target Heart Rate Calculator',
      }),
      value: '#',
      dataEventCategory: 'Breadcrumb',
    },
  ]

  return (
    <>
      <NavigatorLayout
        title={f({
          id: 'targetHeartRate.seoTitle',
          defaultMessage: 'Target Heart Rate Calculator',
        })}
        description={f({
          id: 'targetHeartRate.seoDescription',
          defaultMessage: 'Target Heart Rate Calculator',
        })}
        image={`https://${DEPLOY_ENV === 'staging' ? 'discover.' : ''}${
          domainLocales[locale]
        }${assetImagePath}/thumbnail-target-heart-rate.png?v=1`}
        SEOData={{
          schemaData: f({
            id: 'targetHeartRate.seoSchema',
            defaultMessage: 'Target Heart Rate Calculator',
          }),
          apiMetaData: thrContent?.metaTag,
          isIndexable: true,
        }}
        footerInfo={footerInfo}
        dataNavMenuContent={dataNavMenuContent}
        activeMenuService="tools"
      >
        <StyledThrHealthTool>
          <ToolsBannerCardV2
            breadcrumbProps={{ pageItem }}
            icon={
              <img
                alt="health-tool-icon"
                loading="lazy"
                src={
                  thrContent?.featured_image ||
                  CommonGAssets.getAssetPath(
                    'health-tools/target-heart-rate-icon.svg',
                  )
                }
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            }
            heading={
              thrContent.title ||
              f({
                id: 'targetHearRate.heading',
                defaultMessage: 'Target Heart Rate Calculator',
              })
            }
            description={
              thrContent.description ||
              f({
                id: 'targetHearRate.description',
                defaultMessage:
                  'Use our calorie-intake calculator to determine your daily caloric needs based on your height, weight, age and activity level.',
              })
            }
            isMobile={isMobile}
            reviewBy={thrContent?.reviewBy}
          />
          <HealthToolLayout>
            <HealthToolLayout.LeftColumn>
              <form onSubmit={form.onSubmit(onSubmit)}>
                <Stack spacing={rem(24)}>
                  <Flex
                    gap={rem(24)}
                    sx={(theme) => ({
                      [theme.fn.smallerThan('sm')]: {
                        flexDirection: 'column',
                      },
                      [theme.fn.largerThan('sm')]: {
                        '& > div': {
                          width: '100%',
                          flexGrow: 1,
                        },
                      },
                    })}
                  >
                    <StyledFormControl>
                      <AgeInput
                        {...form.getInputProps('birthday')}
                        disableSSOAge={!isCheckYourself}
                        onChange={(v) => {
                          setInfo({
                            ...info,
                            age: dayjs(v).format(API_DATE_FORMAT),
                          })
                          form.setFieldValue('birthday', v as Date)
                        }}
                      />
                    </StyledFormControl>
                    {isLoggedIn && (
                      <StyledFormControl>
                        <CheckYourSelfSwitching
                          checked={isCheckYourself}
                          onChange={(e) =>
                            setIsCheckYourself(e.currentTarget.checked)
                          }
                        />
                      </StyledFormControl>
                    )}
                  </Flex>
                  <GenderOptionControl
                    label={f({
                      id: 'tool.selectGender',
                      defaultMessage: 'What is your gender?',
                    })}
                    availableValue={checkAvailableGenderOpt(
                      form.getInputProps('gender').value,
                    )}
                    {...form.getInputProps('gender')}
                    onChange={(v) => {
                      setGenderValue(v)
                      setHeartRate([60])
                      form.setFieldValue('gender', v)
                    }}
                  />
                  <StyledSlider>
                    <Text
                      size="s4"
                      weight="semiBold"
                      color="gray.6"
                      style={{ marginBottom: '0.5rem' }}
                    >
                      {f({
                        id: 'targetHeartRate.heartRateInput',
                        defaultMessage: 'Your resting heart rate?',
                      })}{' '}
                      <span
                        style={{
                          color: `${theme.colors.gray300}`,
                        }}
                      >
                        {f({
                          id: 'targetHeartRate.heartRateInput.desc',
                          defaultMessage: ' (bpm)',
                        })}
                      </span>
                    </Text>
                    <SingleSlider
                      min={
                        genderValue === 'male'
                          ? range.rangeMale
                          : range.rangeFemale
                      }
                      max={200}
                      step={1}
                      value={heartRate}
                      onChange={setHeartRate}
                    />
                    <div
                      className="noteInput"
                      onClick={openHowToMeasure}
                      role="button"
                      tabIndex={0}
                    >
                      <span>
                        {f({
                          id: 'targetHeartRate.measureHeartRate',
                          defaultMessage: 'How to measure resting heart rate?',
                        })}
                      </span>
                    </div>
                  </StyledSlider>
                  {isAdult && (
                    <StyledActive>
                      <Label
                        size="label2"
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          color: theme.colors.gray600,
                          marginBottom: '9px',
                        }}
                        htmlFor="gender-selector"
                      >
                        {f({
                          id: 'targetHeartRate.selectActive',
                          defaultMessage: 'How active are you on daily basic?',
                        })}
                      </Label>
                      <div className="card">
                        <RadioImageGroupForTool
                          options={activeValueNote.map((option) => ({
                            value: option.value,
                            label: option.label,
                            image: option.image,
                            imageActive: option.imageActive,
                          }))}
                          value={activeValue}
                          onChange={(v) => {
                            setActiveValue(v)
                          }}
                          className="gender-selector"
                        />
                      </div>
                      {activeValue && (
                        <div className="note">
                          <StyledImageIcon
                            src={`${assetImagePath}/info-icon.svg`}
                          />
                          <Text size="n1" color="gray.6">
                            {
                              activeValueNote[
                                activeValueNote.findIndex(
                                  (x: any) => x.value == activeValue,
                                ) || 0
                              ]?.content
                            }
                          </Text>
                        </div>
                      )}

                      {!activeValue && (
                        <span style={{ color: '#e64728' }}>
                          {inputErrorMessage.intensity}
                        </span>
                      )}
                    </StyledActive>
                  )}
                  <StyledSubmitButton>
                    <ToolsSubmitButton
                      source="Health Tool"
                      toolName="Target Heart Rate"
                      title={f({
                        id: 'bmi.submit',
                        defaultMessage: 'Calculate',
                      })}
                      link={getHealthToolLink(HEALTH_TOOL_TYPE.THR)}
                    />
                  </StyledSubmitButton>
                </Stack>
              </form>
              {enabledAd && isMobile && (
                <AdBlock
                  adUnitPath={adUnitPath}
                  className="top-ad"
                  size={[300, 250]}
                  divId={'div-gpt-ad-topbanner-mobile'}
                  pos={['TopBanner']}
                />
              )}
              {thrInfo && thrInfo.items && thrInfo.items.length > 0 && (
                <>
                  <StyledInfo>
                    <ToolsInfoCard
                      icon={
                        <StyledImageIcon
                          src={`${assetImagePath}/info-icon.svg`}
                        />
                      }
                      headingTitle={thrInfo.title}
                    >
                      <StyledBMIInfo id="expandedCard">
                        {thrInfo.items?.map((item, iItem) => (
                          <ExpandedCard
                            key={'info-' + iItem}
                            isExpand={openInfo === iItem}
                            onChange={(value: boolean) =>
                              value ? setOpenInfo(iItem) : setOpenInfo(-1)
                            }
                            title={item.title}
                            contentString={item.description}
                            iconPosition="right"
                            isMobile={isMobile}
                          />
                        ))}
                      </StyledBMIInfo>
                    </ToolsInfoCard>
                  </StyledInfo>
                  {isMobile && <div className="top-ad"></div>}
                </>
              )}
              {false && <RelationTool />}
            </HealthToolLayout.LeftColumn>
            <HealthToolLayout.RightColumn>
              {enabledAd && !isMobile && (
                <StyledRightColumnContainer>
                  <div className="top-ad">
                    <AdBlock
                      adUnitPath={adUnitPath}
                      size={[
                        [300, 250],
                        [300, 600],
                      ]}
                      divId={'div-gpt-ad-topbanner-desktop'}
                      pos={['TopBanner']}
                    />
                  </div>
                  <div className="bottom-ad"></div>
                </StyledRightColumnContainer>
              )}
            </HealthToolLayout.RightColumn>
          </HealthToolLayout>
          {enabledAd && (
            <Container>
              <FixedBottomAdBlock
                adUnitPath={adUnitPath}
                className="article-bottom-ad"
                isMobile={isMobile}
              />
            </Container>
          )}
        </StyledThrHealthTool>
        {isMobile && <HealthToolBreadcrumb pageItem={pageItem} />}
      </NavigatorLayout>
      <MobileBottomNavigationWrapper.FitnessHealthTool />
    </>
  )
}

export default THRToolPage
